(async () => {
  if (!customElements.get('product-media')) {
    const { default: Swiper, Navigation, Mousewheel } = await import('swiper');
    const { Fancybox } = await import('@fancyapps/ui');

    Swiper.use([Navigation, Mousewheel]);

    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        this.swiper();
        this.fancybox();
      }

      swiper() {
        // Check if Swiper exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        // Get swiper element
        this.swiperElement = this.querySelector('[data-product-media-swiper]');

        // Swiper options
        this.swiperOptions = {
          loop: true,
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: '8px',
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
          },
        };

        // Init swiper
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        // Rebuid Swiper in design mode
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
          Image: {
            Panzoom: {
              maxScale: function () {
                return 2.5;
              },
            },
          },
          Carousel: {
            Navigation: {
              nextTpl: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3718 11L13.5432 8.17142L14.9574 6.7572L20.2002 12L14.9574 17.2427L13.5432 15.8285L16.3718 13H4.00041V11H16.3718Z" fill="currentColor"/>
            </svg>`,
              prevTpl: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.62823 13L10.4568 15.8286L9.04256 17.2428L3.7998 12L9.04256 6.7573L10.4568 8.17151L7.62823 11H19.9996V13H7.62823Z" fill="currentColor"/>
            </svg>`,
            },
          },
          Toolbar: {
            items: {
              close: {
                type: 'button',
                label: 'CLOSE',
                class: 'fancybox__button--close',
                html: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75744 6.34315L6.34323 7.75736L10.5859 12L6.34323 16.2426L7.75744 17.6569L12.0001 13.4142L16.2427 17.6569L17.6569 16.2426L13.4143 12L17.6569 7.75736L16.2427 6.34315L12.0001 10.5858L7.75744 6.34315Z" fill="currentColor"/>
                  </svg>`,
              },
            },
          },
        });
      }
    }

    window.ProductMedia = ProductMedia;

    customElements.define('product-media', ProductMedia);
  }
})();
